export default {
    REACT_APP_API_BASE: process.env.REACT_APP_API_BASE || `http://localhost:8080/api`,
    API_ENDPOINT: 'https://petfulserverjc.herokuapp.com/api',
}